/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Pipe, PipeTransform} from '@angular/core';

import {LocalizationService} from '../localization/localization.service';
import {isPresent} from '../utils/lang';

/**
 * GP-specific pipe to format numbers.
 */
@Pipe({name: 'gpNumber', pure: false})
export class NumberFormatPipe implements PipeTransform {

  constructor(private localization: LocalizationService) {
  }

  public transform(value: any, gpFormat: string, locale?: string, currency?: string): string {
    if (!isPresent(value) || isNaN(value)) {
      return undefined;
    }

    return this.localization.localizeNumber(value, gpFormat, locale, currency);
  }
}
